import { createSlice } from '@reduxjs/toolkit';

import { messageAdded } from '../../actions/cabinListActions';

// Keeps the existing message when the action carries none, as the old `if (action.message)` did.
const messageSlice = createSlice({
  name: 'message',
  initialState: null,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(messageAdded, (state, action) => action.payload ?? state);
  },
});

export default messageSlice.reducer;
